"use client";

import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { ILeanProductTile } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";

import { useOnProductClickBase } from "../../../productTileActions/useOnProductClickBase";

export const ProductLinkForSDUIEvaluateTile = ({
  productToken,
  productUrl,
  productTile,
  children,
}: {
  productUrl: string;
  productTile: ILeanProductTile;
  productToken: string;
  children: ReactNode;
}) => {
  const onProductClick = useOnProductClickBase({
    token: productTile.product?.token,
    bestImage: productTile.best_image,
    images: productTile.images,
    impressionId: productTile.product?.impression_id ?? "",
    promotedBy: productTile.product?.promoted_by ?? [],
  });

  return (
    <ProductLink
      onClick={onProductClick}
      data-test-id={`product-tile-link-${productToken}`}
      to={productUrl ?? ""}
    >
      {children}
    </ProductLink>
  );
};

const ProductLink = styled(Link)`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;
